import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../../../../../../../../commons/formik/FormikActions";
import FormikTextField from "../../../../../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../../../../../styled/Prevencion";
import { validateResponsableProteccionRadiologica } from "../../../../../formValidations";

const ProtRadForm = ({ open, handleClose, handleSubmit, values }) => {

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>
                Administrar Encargados de Protección Radiológica
            </DialogTitle>
            <Formik
                initialValues={values}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validateResponsableProteccionRadiologica}
            >
                {() => (
                    <Form>
                        <DialogContent>
                            <Grid container>
                                {/* Cuil del Responsable */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="cuitResponsable"
                                        label="CUIL del Responsable *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Matrícula Profesional */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="matriculaProfesional"
                                        label="Matrícula Profesional y Entidad Habilitante *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Título Profesional */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="tituloProfesional"
                                        label="Título Profesional *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Nro. Habilitación */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="numeroHabilitacion"
                                        label="Nro. Habilitación *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ProtRadForm;
